import { useTheme } from '@mui/material';

import { Icons, Typography, Box, Stack, tokens } from '@cast/design-system';

import { InlineWithDescription } from 'components/form-layouts';

import { RffInput } from '@cast/shared-rff-ui';

export const NameSection = () => {
  const theme = useTheme();

  return (
    <InlineWithDescription
      px={32}
      bgcolor={tokens.theme.bg.status.infoSubtle}
      borderBottom="none"
      description={
        <Stack direction="row" gap={8}>
          <Box>
            <Icons.Info size={16} color={theme.palette.grey[800]} />
          </Box>
          <Typography variant="P12R" color="text.secondary">
            Please note that you will not be able to edit or change the
            configuration name after saving it.
          </Typography>
        </Stack>
      }
      controls={
        <RffInput
          name="name"
          label="Configuration name"
          inputProps={{
            placeholder: 'e.g. compute-optimized',
          }}
          testId="configuration-name-input"
        />
      }
    />
  );
};
